// Emits the SAME `feed_video_play` usage-log entry that
// routes/videostreaming/player.js (loadHls, both the hls.js and native-Safari
// branches) and components/gui/listFrontpage.js (playVideo) already send.
//
// Neither of those call sites posts to the network directly — they push onto
// the MobX-observable appState.usageLog via the @action appState.addUsageLog(),
// and app.js's sendLogs() timer batches it every 10s into a single
// POST /api/usageLogs/ with body { usage: appState.usageLog } (see
// webapp/src/app.js sendLogs()/startLogTimer()). backend/app/routes/api/
// usageLogs/post-usage-log.js inserts each queued entry as its own UsageLog row.
//
// backend/bin/aggregate-usage-stats.js groups rows where type === 'feed_video_play'
// by `props.articleId` into a per-article `videoPlays` count, which is summed
// into article.totalVideoPlays — the field the frontpage highlights ranking
// now weights. Only `type` and `props.articleId` are read by that aggregation;
// matching those exactly is what makes shorts plays count at all.
//
// Fire-and-forget: play tracking must never interrupt playback, so failures
// (e.g. stores not ready) are swallowed rather than surfaced.
export async function trackVideoPlay({ stores, articleId }) {
    if (!articleId || !stores || !stores.appState) {
        return;
    }
    try {
        stores.appState.addUsageLog({
            type: 'feed_video_play',
            props: {
                articleId,
            },
            timestamp: Math.floor(new Date().getTime() / 1000),
        });
    } catch (err) {
        // ignored on purpose
    }
}

export default { trackVideoPlay };
